import { render } from "./IPColumn.vue?vue&type=template&id=0ed62e95&scoped=true&ts=true"
import script from "./IPColumn.vue?vue&type=script&lang=ts"
export * from "./IPColumn.vue?vue&type=script&lang=ts"

import "./IPColumn.vue?vue&type=style&index=0&id=0ed62e95&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed62e95"]])

export default __exports__